import dom, { Fragment } from "jsx-render";
import {
    b64Uri,
    cleanFloat,
    formatCurrency,
    getData,
    getElement,
    getJson,
    resetForm,
    Management,
    DecimalLength,
} from "../../../../../helpers";
import { dataBank } from "../../../../../components/selectBank";
import moment from "moment";
export class PaymentReturnModal extends HTMLDivElement {
    constructor(element = null) {
        super(); // Llama al constructor de HTMLDivElement

        if (element) {
            // Heredar de la clase al elemento del DOM
            Object.setPrototypeOf(element, PaymentReturnModal.prototype);
            return element;
        }
    }

    connectedCallback() {
        this.addEvents();
    }

    calcTotal() {
        const IptsPay = this.querySelectorAll(".pay");
        let total = Array.from(IptsPay).reduce((acc, item) => {
            acc += cleanFloat(item.value == "-" ? 0 : item.value);
            return acc;
        }, 0);

        const Amount = getElement("[name=amount]", this);
        Amount.value = formatCurrency(total.toFixed(DecimalLength), "decimal");
    }

    addEvents() {
        const Form = getElement("[data-form=form]", this);

        this.addEventListener("click", (e) => {
            const Target = e.target;

            if (Target.hasAttribute("data-total")) {
                let total = getData(Target, "data-total");
                const IptTotalLine = Target.previousElementSibling;
                IptTotalLine.value = total;
                this.calcTotal();
            }

            if (Target.name == "save") {
                const Form = getElement("[data-form=form]", this);

                if (Form.reportValidity()) {
                    Form.submit();
                }
            }
        });

        this.addEventListener("input", (e) => {
            // const Target = e.target;

            /*if (Target.hasAttribute("data-number")) {
                let totalLine = cleanFloat(
                    getData(Target.nextElementSibling, "data-total")
                );
                let val = cleanFloat(Target.value);

                if (val > totalLine) {
                    Target.value = formatCurrency(totalLine, "decimal");
                }

            }*/

            this.calcTotal();
        });

        this.addEventListener("aj:select2", (e) => {
            const Data = e.detail.data;

            Form.elements.bank_id.removeAttribute("required");

            if (Data.need_bank) {
                Form.elements.bank_id.setAttribute("required", "");
            }
        });
    }

    create(modal, title, url) {
        const Form = getElement("[data-form=form]", getElement(modal));
        resetForm(Form, title, url);
        dataBank.companies = [Management.company_id];
        const TBody = getElement("[data-target=tbody]", Form);
        TBody.innerHTML = "";

        const IptsChecked = Array.from(
            document.querySelectorAll("[name=check]")
        ).filter((item) => item.checked);

        IptsChecked.forEach((item) => {
            let data = getJson(b64Uri(getData(item, "data-data"), "decode"));
            let date = moment(data.date_invoice);
            Form.elements.description.value += `, #${
                data.ref_invoice ?? data.ref
            }`;
            let totalLine = data.lines.reduce((acc, item) => {
                acc += parseFloat(item.total_line);
                return acc;
            }, 0);

            let paid = data.payments.reduce((acc, item) => {
                acc += parseFloat(item.pivot.amount);
                return acc;
            }, 0);

            let total = formatCurrency(totalLine - paid);

            const Tr = (
                <tr>
                    <td class="text-center">{data.ref}</td>
                    <td class="text-center">
                        {date.format(getData(Form, "data-date-format"))}
                    </td>
                    <td class="text-end">{total}</td>
                    <td class="text-center">
                        <div class="input-group input-group-sm mt-1">
                            <input
                                type="text"
                                class="form-control form-control-sm text-end pay"
                                data-number
                                data-signal="+"
                                name={`invoice[${data.id}]`}
                                required
                            />
                            <i
                                class="input-group-text fa-solid fa-money-bill-transfer pt-2"
                                data-total={formatCurrency(
                                    totalLine - paid,
                                    "decimal"
                                )}
                            ></i>
                        </div>
                    </td>
                </tr>
            );

            TBody.appendChild(Tr);
        });

        this.calcTotal();
    }
}

window.customElements.define("paymentreturn-modal", PaymentReturnModal, {
    extends: "div",
});
